module.exports = __webpack_public_path__ + "static/media/whatsapp.c51d97c3.svg";